import React from 'react';

import { UiSignupLayout } from '../../common/UiSignup';
import InviteLeftContainer from './subcomponents/InviteLeftContainer';
import InviteRightContainer from './subcomponents/InviteRightContainer';

const InvitePageComponent = () => {
    return <UiSignupLayout
        left={<InviteLeftContainer />}
        right={<InviteRightContainer />} />;
};

export default InvitePageComponent ;
